import Box from "@mui/material/Box";
import { useTheme, type SxProps } from "@mui/material/styles";
import { ReactNode } from "react";
import QueueWidget from "../queue-widget";
import useSunoDialer from "../use-suno-dialer.hook";
import Draggable from "react-draggable";
import { useFlags } from "launchdarkly-react-client-sdk";
import { SUNO_DIALER_CALLS_QUEUE_FEATURE } from "constants/feature-flags";
import OutgoingCallWidget from "../outgoing-call-widget/outgoing-call-widget.component";

type DialerWidgetContainerProps = {
  sx?: SxProps;
  className?: string;
  children?: ReactNode;
};

export default function DialerWidgetContainer({
  className = "animate__animated animate__slideInRight animate__faster",
  sx,
  children,
}: DialerWidgetContainerProps) {
  const flags = useFlags();

  const isCallsQueueFeature = flags[SUNO_DIALER_CALLS_QUEUE_FEATURE];

  const theme = useTheme();

  const {
    displaySettings: { showQueue },
    activeCall,
    incomingCall,
  } = useSunoDialer();

  return (
    <Draggable>
      <div
        style={{
          position: "absolute",
          right: 30,
          bottom: 20,
          zIndex: theme.zIndex.snackbar + 1,
        }}
      >
        {!activeCall?.id && !incomingCall?.id && <OutgoingCallWidget />}
        <Box
          className={className}
          sx={{
            minWidth: showQueue ? "447px" : undefined,
            maxWidth: showQueue ? undefined : "410px",
            ...sx,
          }}
        >
          {children}
          {isCallsQueueFeature && <QueueWidget />}
        </Box>
      </div>
    </Draggable>
  );
}
